/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
if(typeof Geolizr === "object") {
  var checkPopup = function(id) {
    var locale = Geolizr.getURLParameter('locale');
    if(typeof locale !== "undefined") {
      Geolizr.cookie.set('geolizr-dismissed-popup-' + id, 'true', {expires: 14, path: '/', domain: Geolizr.shopDomain });
    }
  }
  
  Geolizr.init(function() {
    Object.keys(Geolizr.popups).forEach(function(id) {
      checkPopup(id);
    });
  });
  
  Geolizr.addEventListener('popup.preShow', function(popup) {
  	checkPopup(popup.id);
  });
}